import { InfoOutlineIcon } from "@chakra-ui/icons";
import {
  Box,
  Container,
  Divider,
  Heading,
  Icon,
  Spinner,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { FaClipboardCheck, FaFileContract, FaUserShield } from "react-icons/fa"; // Icons for different sections
import { useTerms } from "../../hooks/useTerms.ts"; // Assuming the hook is in the hooks folder

const Terms = () => {
  const { data, isLoading, error } = useTerms();

  const bgColor = useColorModeValue("gray.50", "gray.800");
  const titleColor = useColorModeValue("blue.600", "blue.300");

  if (isLoading) {
    return (
      <Container maxW="container.xl" py={150} textAlign="center">
        <Spinner size="xl" />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxW="container.xl" py={150} textAlign="center">
        <Box color="red.500">
          Error loading terms and conditions. Please try again later.
        </Box>
      </Container>
    );
  }

  return (
    <Box bg={bgColor} py={10} pt="100px">
      {" "}
      {/* Added pt="100px" for top padding */}
      <Container maxW="container.xl" py={10}>
        {/* Main Heading */}
        <Heading
          as="h1"
          size="2xl"
          color={titleColor}
          textAlign="center"
          mb={8}
        >
          {data?.title || "Terms & Conditions"}
        </Heading>

        {/* Section 1: Intro */}
        <Stack spacing={6} mb={10} align="center">
          <Box w="full" textAlign="center">
            <InfoOutlineIcon boxSize={10} color={titleColor} mb={3} />

            <Text fontSize="lg" color="gray.600" mt={3}>
              By using our services, you agree to the terms and conditions
              outlined below.
            </Text>
          </Box>
        </Stack>

        {/* Section 2: Main Content */}
        <Stack spacing={8} mb={10}>
          {/* Terms Section */}
          <Box>
            <Stack direction="row" align="center" mb={4}>
              <Icon as={FaFileContract} w={8} h={8} color={titleColor} />
              <Heading as="h3" size="md" color={titleColor}>
                Agreement Terms
              </Heading>
            </Stack>
            <Text fontSize="md" lineHeight="taller">
              {/* Render the content from API (HTML) */}
              <Box dangerouslySetInnerHTML={{ __html: data?.body }} />
            </Text>
          </Box>

          <Divider />

          {/* Section 3: User Responsibility */}
          <Box>
            <Stack direction="row" align="center" mb={4}>
              <Icon as={FaUserShield} w={8} h={8} color={titleColor} />
              <Heading as="h3" size="md" color={titleColor}>
                User Responsibility
              </Heading>
            </Stack>
            <Text fontSize="md" lineHeight="taller">
              As a user, you are responsible for maintaining your account and
              abiding by the terms.
            </Text>
          </Box>

          <Divider />

          {/* Section 4: Legal Compliance */}
          <Box>
            <Stack direction="row" align="center" mb={4}>
              <Icon as={FaClipboardCheck} w={8} h={8} color={titleColor} />
              <Heading as="h3" size="md" color={titleColor}>
                Legal Compliance
              </Heading>
            </Stack>
            <Text fontSize="md" lineHeight="taller">
              We follow all applicable laws and regulations to ensure your
              rights are protected. Any updates to these terms will be
              communicated promptly.
            </Text>
          </Box>
        </Stack>

        {/* Additional Legal Section */}
        <Box textAlign="center" mt={10}>
          <Text fontSize="lg" fontWeight="bold">
            Thank you for reading and agreeing to our terms and conditions.
          </Text>
        </Box>
      </Container>
    </Box>
  );
};

export default Terms;
